/* eslint-disable no-unused-vars */
import React from "react";
import { Modal } from "react-bootstrap";
// import { CircularProgressbar } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import Basic from "../CorporateFields/Basic";
import CompanyBuisness from "../CorporateFields/CompanyBuisness";
// import CompanyInformation from "../CorporateFields/CompanyInformation";
import CorporateRepInfo from "../CorporateFields/CorporateRepInfo";
import "./modal.css";

function KycCoporateModal({
  show,
  handleClose,
  dictionary,
  countries,
  actionType,
  dataCollectionFormType,
  associatedRuleId,
  customerId,
  companyCode,
  title,
  userId,
}) {
  return (
    <Modal
      show={show}
      backdrop="static"
      keyboard={false}
      onHide={() => {
        handleClose();
        // setHandleData([]);
      }}
      onBackdropClick={() => {
        handleClose();
      }}
      size={"xl"}
      // fullscreen
    >
      <Modal.Header closeButton style={{ background: "#C2DBFF" }}>
        <Modal.Title className="d-flex flex-row align-items-center mt-3 ps-5 ms-5">
          {/* <div className="pe-3" style={{ width: "81px" }}>
            <CircularProgressbar value={66} maxValue={1} text={`66%`} />
          </div> */}
          <div className="pt-3">
            <p className="d-flex flex-column">
              <span className="verify">
                Let’s verify your company’s identity
              </span>
              <span className="fill">
                {" "}
                Please fill the information below to complete your verification
                process
              </span>
            </p>
          </div>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {dataCollectionFormType === "COMPANY_STRUCTURE_INDIVIDUAL" ||
        dataCollectionFormType === "COMPANY_STRUCTURE_COOPERATE" ? (
          <>
            <CorporateRepInfo
              dictionary={dictionary}
              countries={countries}
              associatedRuleId={associatedRuleId}
              handleClose={handleClose}
              customerId={customerId}
              title={title}
              actionType={actionType}
              userId={userId}
            />
          </>
        ) : (
          ""
        )}

        {dataCollectionFormType === "COMPANY_FUND_INFORMATION" && (
          <CompanyBuisness
            dictionary={dictionary}
            countries={countries}
            associatedRuleId={associatedRuleId}
            handleClose={handleClose}
            customerId={customerId}
            title={title}
            actionType={actionType}
          />
        )}

        {dataCollectionFormType === "PASSPORT_FILE_UPLOAD" ||
        dataCollectionFormType === "BASIC_FILE_UPLOAD" ? (
          <Basic
            dictionary={dictionary}
            countries={countries}
            associatedRuleId={associatedRuleId}
            handleClose={handleClose}
            customerId={customerId}
            companyCode={companyCode}
            title={title}
            dataCollectionFormType={dataCollectionFormType}
            actionType={actionType}
          />
        ) : (
          ""
        )}
      </Modal.Body>
      {/* <Modal.Footer></Modal.Footer> */}
    </Modal>
  );
}

export default KycCoporateModal;
